import { useTranslation as useTranslationTyped } from "react-i18next";
import type { i18n } from "i18next";

import type { Namespace } from "./resources";

/**
 * Loosely-typed stand-in for react-i18next's `useTranslation`.
 *
 * react-i18next v15's key-typed `t()` requires `strictNullChecks` — without
 * it the key inference collapses (TS2589) or rejects valid unprefixed keys.
 * This app doesn't enable strictness yet, so components import this wrapper
 * instead of react-i18next directly: identical runtime, same unprefixed key
 * idiom as mobile, no compile-time key checking.
 *
 * When the app turns on `strictNullChecks`, delete this module, point imports
 * back at react-i18next, and add mobile's `i18next.d.ts` catalog augmentation
 * (see frontend/mobile/src/i18n/i18next.d.ts) for fully typed keys.
 */
export type TranslateFunction = (
  key: string | string[],
  options?: Record<string, unknown>
) => string;

type UseTranslationResponse = {
  t: TranslateFunction;
  i18n: i18n;
  ready: boolean;
};

export const useTranslation = useTranslationTyped as (
  ns?: Namespace | readonly Namespace[]
) => UseTranslationResponse;
